import { type UseMutationOptions, type UseMutationResult, useMutation } from "@suse-o11y/query";

import { type LicenseKey, type SubscriptionState, Type } from "~/models/dto";

import { type HTTPError, request } from "../generic/request";

export const useUpdateLicenseKey = <TContext = unknown>(
	options?: UseMutationOptions<SubscriptionState, HTTPError, string, TContext>,
): UseMutationResult<SubscriptionState, HTTPError, string, TContext> =>
	useMutation((licenseKey) => {
		const license: LicenseKey = {
			_type: Type.LicenseKey,
			key: licenseKey,
		};

		return request<SubscriptionState>("/api/subscription", {
			method: "POST",
			body: license,
		});
	}, options);
